export const fetchInventoriesUseCase = async (inventoryApi) => {
    try {
      const response =  await inventoryApi.getInventoryApi();
      return response;
    } catch (error) {
      throw new Error('Failed to fetch inventory');
    }
};